import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import HighlightedProducts from '@shopDetails/components/HighlightedProducts';
import DiscountsProducts from '@shopDetails/components/DiscountsProducts';
import PreferredDishes from '@shopDetails/components/PreferredDishes';
import {
  HIGHLIGHTED_PRODUCTS_SECTION_ID,
  DISCOUNTS_PRODUCTS_SECTION_ID,
  PREFERRED_DISHES_SECTION_ID,
} from '@shopDetails/constants';

const FIRST_POSITION = 1;
const SECOND_POSITION = 2;
const THIRD_POSITION = 3;

function Swimlanes({
  highlightedProducts,
  discountsProducts,
  countryCode,
  onBeforeProductConfig,
  getRefs,
  trackSwimlane,
  preferredDishesProducts,
  trackSwimlaneSwiped,
}) {
  const hasPreferredDishesProducts = useMemo(
    () => preferredDishesProducts?.length > 1,
    [preferredDishesProducts],
  );

  const hasDiscountProducts = useMemo(() => discountsProducts?.length > 1, [
    discountsProducts,
  ]);

  const highlightedProductsPosition = useMemo(() => {
    if (hasPreferredDishesProducts && hasDiscountProducts) {
      return THIRD_POSITION;
    }
    if (!hasPreferredDishesProducts && hasDiscountProducts) {
      return SECOND_POSITION;
    }
    if (hasPreferredDishesProducts && !hasDiscountProducts) {
      return SECOND_POSITION;
    }
    return FIRST_POSITION;
  }, [hasPreferredDishesProducts, hasDiscountProducts]);

  return (
    <>
      <div ref={el => getRefs(PREFERRED_DISHES_SECTION_ID, el)}>
        <PreferredDishes
          onBeforeProductConfig={onBeforeProductConfig}
          trackSwimlane={trackSwimlane}
          trackSwimlaneSwiped={trackSwimlaneSwiped}
          position={hasPreferredDishesProducts && FIRST_POSITION}
        />
      </div>
      <div ref={el => getRefs(DISCOUNTS_PRODUCTS_SECTION_ID, el)}>
        <DiscountsProducts
          products={discountsProducts}
          onBeforeProductConfig={onBeforeProductConfig}
          trackSwimlane={trackSwimlane}
          trackSwimlaneSwiped={trackSwimlaneSwiped}
          position={
            hasPreferredDishesProducts ? SECOND_POSITION : FIRST_POSITION
          }
        />
      </div>
      <div ref={el => getRefs(HIGHLIGHTED_PRODUCTS_SECTION_ID, el)}>
        <HighlightedProducts
          products={highlightedProducts}
          countryCode={countryCode}
          onBeforeProductConfig={onBeforeProductConfig}
          trackSwimlane={trackSwimlane}
          trackSwimlaneSwiped={trackSwimlaneSwiped}
          position={highlightedProductsPosition}
        />
      </div>
    </>
  );
}

Swimlanes.propTypes = {
  highlightedProducts: PropTypes.array.isRequired,
  countryCode: PropTypes.string.isRequired,
  onBeforeProductConfig: PropTypes.func.isRequired,
  getRefs: PropTypes.func.isRequired,
  discountsProducts: PropTypes.array.isRequired,
  trackSwimlane: PropTypes.func.isRequired,
  preferredDishesProducts: PropTypes.array.isRequired,
  trackSwimlaneSwiped: PropTypes.func.isRequired,
};

export default Swimlanes;
